import axios from "axios";
import { BACKEND_ADDRESS } from "./constants";

// Separate instance for the waitlist endpoints — they sit behind
// requireLandingPageLogin on the backend, which checks the raw Authorization
// header for an exact match against LANDING_PAGE_SECRET_TOKEN (no "Bearer "
// prefix). appAxios always sends "Bearer <token>", so it can't be reused here.
const waitlistAxios = axios.create({ baseURL: BACKEND_ADDRESS });

waitlistAxios.interceptors.request.use((req) => {
  req.headers.authorization = process.env.REACT_APP_LANDING_PAGE_SECRET_TOKEN || "";
  return req;
});

export default waitlistAxios;
